import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { PageHeader } from '~/components/tapestry'

import Headers from './headers.jsx'

const Request = (props) => {
  const { request_body, request_headers } = props.attributes
  const body = JSON.stringify(JSON.parse(request_body), null, 2)

  return (
    <>
      <p>
        <b>Headers</b>
      </p>

      <Headers headers={request_headers} />

      <p>
        <b>Body</b>
      </p>

      <pre>
        <code>{body}</code>
      </pre>
    </>
  )
}

const Response = (props) => {
  const { response_body, response_headers } = props.attributes
  return (
    <>
      <p>
        <b>Response Headers</b>
      </p>
      <Headers headers={response_headers} />
      <p>
        <b>Response Body</b>
      </p>
      <pre>
        <code>{response_body}</code>
      </pre>
    </>
  )
}

const Content = (props) => {
  return (
    <div className="webhook-delivery__body">
      <PageHeader
        className="webhook-delivery__tabs"
        inactive={false}
        profile={false}
        navigation={
          <ul style={{ padding: 0 }}>
            <li>
              <button
                {...(props.isRequest ? { className: 'selected' } : {})}
                onClick={props.onToggle}
              >
                Request
              </button>
            </li>
            <li>
              <button
                {...(!props.isRequest ? { className: 'selected' } : {})}
                onClick={props.onToggle}
              >
                Response
              </button>
            </li>
          </ul>
        }
      />

      {props.isRequest ? (
        <Request attributes={props.attributes} />
      ) : (
        <Response attributes={props.attributes} />
      )}
    </div>
  )
}

const Timing = (props) => {
  const { time } = props
  let label = ''
  if (time < 1.0) {
    label = `${(time * 1000.0).toFixed(0)}ms`
  } else if (time < 60.0) {
    label = `${time.toFixed(1)}s`
  } else {
    label = `${(time / 60.0).toFixed(1)}m`
  }
  return <span> {label}</span>
}

export default class Delivery extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    attributes: PropTypes.object.isRequired,
  }

  state = {
    isRequest: true,
    isExpanded: false,
  }

  deliveryStatusBadgeTheme = () => {
    if (
      this.props.attributes.status >= 200 &&
      this.props.attributes.status <= 299
    ) {
      return 'badge--success-solid'
    } else if (
      this.props.attributes.status >= 300 &&
      this.props.attributes.status <= 399
    ) {
      return 'badge--warning-solid'
    } else {
      return 'badge--error-solid'
    }
  }

  render() {
    return (
      <div className="webhook-delivery">
        <div
          className="webhook-delivery__header"
          onClick={() => {
            this.setState({ isExpanded: !this.state.isExpanded })
          }}
        >
          <span className="badge">Delivery</span>

          <code className="webhook-delivery__timestamp">
            {moment(this.props.attributes.created_at).format(
              'YYYY-MM-DD kk:mm:ss Z'
            )}
          </code>

          <span className="badge badge--sm badge--neutral-subtle">
            <Timing time={this.props.attributes.timing} />
          </span>

          <span
            className={`badge badge--sm ${this.deliveryStatusBadgeTheme()} webhook-delivery__status`}
            data-webhook-delivery-status={this.props.attributes.status}
          >
            {this.props.attributes.status}
          </span>
        </div>

        {this.state.isExpanded ? (
          <Content
            isRequest={this.state.isRequest}
            attributes={this.props.attributes}
            onToggle={() => {
              this.setState({
                isRequest: !this.state.isRequest,
              })
            }}
          />
        ) : null}
      </div>
    )
  }
}
